import React from 'react';
import ComingSoon from '../../../components/ComingSoon';

export default function Shopify() {
  return <ComingSoon title="Shopify Websites" blurb="Shopify website packages are coming soon." />;
}
